import React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";

const License = styled.p`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.warning.main};
    margin: 0;
`;

const Subscription = ({ plans }) => {
    const getHighestLevelPlan = (selectedPlans) => {
        if (!selectedPlans || selectedPlans.length === 0) return undefined;
        const enterprisePlan = selectedPlans.find((plan) =>
            plan.type.toLowerCase().includes("enterprise")
        );
        if (enterprisePlan) return enterprisePlan;
        const teamPlan = selectedPlans.find((plan) => plan.type.toLowerCase().includes("team"));
        if (teamPlan) return teamPlan;
        const proPlan = selectedPlans.find((plan) => plan.type.toLowerCase().includes("personal"));
        if (proPlan) return proPlan;
        return undefined;
    };

    const getPlanToShow = () => {
        const userAdminPlans = plans && plans.filter((plan) => plan.isAdmin);
        if (userAdminPlans && userAdminPlans.length > 0) {
            return getHighestLevelPlan(userAdminPlans);
        }
        return getHighestLevelPlan(plans);
    };

    const plan = getPlanToShow();
    const getLicenseName = () => {
        if (!plan || !plan.name) return "Freeloader License";
        if (plan.type.toLowerCase().includes("free")) return "Freeloader License";
        if (plan.type.toLowerCase().includes("personal")) return "Personal Pro";
        if (plan.type.toLowerCase().includes("team")) return "Team License";
        if (plan.type.toLowerCase().includes("enterprise")) return "Enterprise License";
        return null;
    };

    return (
        <Stack>
            <License>{getLicenseName()}</License>
        </Stack>
    );
};

export default Subscription;
